export class BalanceRequestParams {
  codigoCliente: number;
  divisao: string;
}
